import { ContactShowcase } from '../components/contact/ContactShowcase';
import { usePageSeo } from '../hooks/usePageSeo';
import { PAGE_SEO } from '../lib/seo';
import '../styles/contact-page.css';

export function ContactPage() {
  usePageSeo(PAGE_SEO.contact);

  return <ContactShowcase />;
}
